import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThumaMinaService {
  details;

  constructor() {}

  setDetails(details) {
    this.details = details;
  }

  getDetails() {
    return this.details;
  }
}
